import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import {
  COMPOSED_REPORT_FYEAR_SOB_TRACKER_MAPPING_ID,
  COMPOSED_REPORT_SOB_TRACKER_MAPPING_ID,
} from '../configs'

export const exportSoBTrackerReport = async (guid: string | null, fyear: number) => {
  const crudOptions = CrudStore.get(CrudStoreItemPartner360.JBPSettings)
  const options = await crudOptions.getById({ id: 1, keyField: 'EntryId' })
  if (options) {
    const url = proxy(`/form/data/export/by/template`)
    Logger.log(url)

    const data = new FormData()
    data.append(
      'Mappings',
      JSON.stringify([
        { EntryId: COMPOSED_REPORT_SOB_TRACKER_MAPPING_ID, Keys: { ReportGUID: guid } },
        {
          EntryId: COMPOSED_REPORT_FYEAR_SOB_TRACKER_MAPPING_ID,
          Keys: { FYear: fyear },
        },
      ])
    )
    const [accessToken] = getTokens()

    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      method: 'POST',
      body: data,
    })

    const filename = `Composed report.xlsx`

    const blob = await res.blob()
    const link = document.createElement('a')
    const uniqueUrl = `${window.URL.createObjectURL(blob)}?${guid}`
    link.href = uniqueUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}
